import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

export default function OrderDetail() {
  const { id } = useParams();
  const [showCancelDialog, setShowCancelDialog] = useState(false);

  const order = {
    id: 'ORD-2024-002',
    date: '2024-01-18',
    status: 'shipping',
    total: 899,
    subtotal: 849,
    shipping: 50,
    items: [
      {
        id: 1,
        name: 'سماعات لاسلكية فاخرة',
        price: 299,
        quantity: 2,
        image: 'https://public.readdy.ai/ai/img_res/d1a6ea14f740c6bf5ac5fffc392bd826.jpg',
        color: 'أسود',
        size: 'متوسط'
      },
      {
        id: 2,
        name: 'حقيبة جلدية أنيقة',
        price: 449,
        quantity: 1,
        image: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20handbag%20luxury%20fashion%2C%20high-quality%20product%20photography%2C%20isolated%20on%20soft%20gradient%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20elegant%20design%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20product%20shot&width=200&height=200&seq=orderdet2&orientation=squarish',
        color: 'بني',
        size: 'كبير'
      }
    ],
    shippingAddress: {
      name: 'أحمد محمد',
      phone: '+966 50 123 4567',
      address: 'شارع الملك فهد، حي النخيل',
      city: 'الرياض',
      postalCode: '12345'
    },
    tracking: [
      { status: 'تم تأكيد الطلب', date: '2024-01-18 10:30', completed: true },
      { status: 'جاري التحضير', date: '2024-01-18 14:20', completed: true },
      { status: 'تم الشحن', date: '2024-01-19 09:15', completed: true },
      { status: 'في الطريق للتوصيل', date: '2024-01-20 08:00', completed: false },
      { status: 'تم التوصيل', date: '', completed: false }
    ]
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 pb-24" dir="rtl">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white/80 backdrop-blur-lg shadow-sm z-50">
        <div className="px-4 py-3 flex items-center justify-between">
          <Link to="/orders" className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-2xl text-gray-800"></i>
          </Link>
          <h2 className="text-lg font-bold text-gray-800">تفاصيل الطلب</h2>
          <button className="w-10 h-10 flex items-center justify-center">
            <i className="ri-customer-service-line text-2xl text-gray-800"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="pt-16 px-4">
        {/* Order Info */}
        <div className="bg-white rounded-2xl p-6 shadow-sm mb-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-sm text-gray-600">رقم الطلب</p>
              <p className="text-lg font-bold text-gray-800">{order.id}</p>
            </div>
            <div className="px-4 py-2 bg-blue-50 rounded-full">
              <p className="text-sm font-bold text-blue-600">قيد الشحن</p>
            </div>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600">تاريخ الطلب</span>
            <span className="font-bold text-gray-800">{order.date}</span>
          </div>
        </div>

        {/* Tracking */}
        <div className="bg-white rounded-2xl p-6 shadow-sm mb-4">
          <h3 className="text-lg font-bold text-gray-800 mb-6">تتبع الشحنة</h3>
          <div className="space-y-6">
            {order.tracking.map((track, index) => (
              <div key={index} className="flex gap-4">
                <div className="flex flex-col items-center">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    track.completed 
                      ? 'bg-gradient-to-r from-blue-500 to-purple-500' 
                      : 'bg-gray-200'
                  }`}>
                    {track.completed ? (
                      <i className="ri-check-line text-white text-xl"></i>
                    ) : (
                      <div className="w-3 h-3 bg-gray-400 rounded-full"></div>
                    )}
                  </div>
                  {index < order.tracking.length - 1 && (
                    <div className={`w-0.5 h-12 ${
                      track.completed ? 'bg-gradient-to-b from-blue-500 to-purple-500' : 'bg-gray-200'
                    }`}></div>
                  )}
                </div>
                <div className="flex-1 pb-4">
                  <p className={`font-bold mb-1 ${
                    track.completed ? 'text-gray-800' : 'text-gray-400'
                  }`}>
                    {track.status}
                  </p>
                  {track.date && (
                    <p className="text-sm text-gray-500">{track.date}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Items */}
        <div className="bg-white rounded-2xl p-6 shadow-sm mb-4">
          <h3 className="text-lg font-bold text-gray-800 mb-4">المنتجات</h3>
          <div className="space-y-4">
            {order.items.map((item) => (
              <div key={item.id} className="flex gap-4">
                <div className="w-20 h-20 bg-gray-100 rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1">
                  <h4 className="text-sm font-bold text-gray-800 mb-1">{item.name}</h4>
                  <div className="flex items-center gap-2 mb-2 text-xs text-gray-600">
                    <span>اللون: {item.color}</span>
                    <span>•</span>
                    <span>المقاس: {item.size}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">الكمية: {item.quantity}</span>
                    <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                      {item.price * item.quantity} ر.س
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Shipping Address */}
        <div className="bg-white rounded-2xl p-6 shadow-sm mb-4">
          <h3 className="text-lg font-bold text-gray-800 mb-4">عنوان التوصيل</h3>
          <div className="space-y-2 text-sm">
            <p className="font-bold text-gray-800">{order.shippingAddress.name}</p>
            <p className="text-gray-600">{order.shippingAddress.phone}</p>
            <p className="text-gray-600">{order.shippingAddress.address}</p>
            <p className="text-gray-600">{order.shippingAddress.city} - {order.shippingAddress.postalCode}</p>
          </div>
        </div>

        {/* Payment Summary */}
        <div className="bg-white rounded-2xl p-6 shadow-sm mb-4">
          <h3 className="text-lg font-bold text-gray-800 mb-4">ملخص الدفع</h3>
          <div className="space-y-3">
            <div className="flex items-center justify-between text-gray-600">
              <span>المجموع الفرعي</span>
              <span className="font-bold">{order.subtotal} ر.س</span>
            </div>
            <div className="flex items-center justify-between text-gray-600">
              <span>الشحن</span>
              <span className="font-bold">{order.shipping} ر.س</span>
            </div>
            <div className="border-t border-gray-200 pt-3 flex items-center justify-between">
              <span className="text-lg font-bold text-gray-800">المجموع الكلي</span>
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                {order.total} ر.س
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Actions */}
      <div className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 px-4 py-4 z-50">
        <div className="flex gap-3">
          <button className="flex-1 py-4 bg-gray-100 text-gray-700 rounded-2xl font-bold hover:bg-gray-200 transition-colors">
            تواصل مع البائع
          </button>
          <button 
            onClick={() => setShowCancelDialog(true)}
            className="flex-1 py-4 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-2xl font-bold shadow-lg"
          >
            إلغاء الطلب
          </button>
        </div>
      </div>

      {/* Cancel Dialog */}
      {showCancelDialog && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4" onClick={() => setShowCancelDialog(false)}>
          <div className="bg-white rounded-3xl p-6 max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-error-warning-line text-3xl text-red-500"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 text-center mb-2">إلغاء الطلب</h3>
            <p className="text-gray-600 text-center mb-6">هل أنت متأكد من رغبتك في إلغاء هذا الطلب؟</p>
            <div className="flex gap-3">
              <button 
                onClick={() => setShowCancelDialog(false)}
                className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-2xl font-bold"
              >
                رجوع
              </button>
              <button className="flex-1 py-3 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-2xl font-bold">
                تأكيد الإلغاء
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
